import { Injectable } from '@angular/core';
import { GlobalConfig } from 'ngx-toastr';

@Injectable()
export class CommonConfig {

    static cameraConfig = {
        width: 640,
        height: 800,
        defaultVideoAspectRatio: 1.8,
        defaultImageQuality: 0.9,
        defaultImageType: 'image/jpg',
        maxPhotoFileSize: 10485760
    };

    static getToastrConfig(): GlobalConfig {
        return {
            timeOut: 7000,
            positionClass: 'toast-bottom-full-width',
            iconClasses: {
                 error: 'toast-error ui-error',
                 info: 'toast-info',
                 success: 'toast-success ui-success',
                 warning: 'toast-warning ui-warning'
            }
        } as GlobalConfig;
    }
}
